"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptClassForCategories = void 0;
const constants_1 = require("./constants");
/**
 * Returns the script class for a given array of categories
 * @param categories Array of cookie categories
 * @returns string - the script class for the given categories
 */
const getScriptClassForCategories = (categories) => {
    return `${constants_1.OPTANON_CATEGORY_PREFIX}${categories.join('-')}`;
};
exports.getScriptClassForCategories = getScriptClassForCategories;
